/* FamilyGiftMall product page: gallery (thumb/arrow/swipe) + sticky mobile ATC.
   Variant selection, price/availability, Ajax add-to-cart all stay with Dawn's
   product-info.js / product-form.js. */

/* Shared: load a deferred gallery image (data-src -> src) on demand. Only the
   first gallery image ships with a real src; the rest defer so the initial page
   load stays light (and the Add-to-cart fetch isn't starved). */
function fgmLoadImg(im) {
  if (im && im.dataset && im.dataset.src) {
    if (im.dataset.srcset) { im.srcset = im.dataset.srcset; }
    im.src = im.dataset.src;
    im.removeAttribute('data-src');
    im.removeAttribute('data-srcset');
  }
}

(function () {
  'use strict';

  /* ---- gallery ---- */
  document.querySelectorAll('[data-fgm-gallery]').forEach(function (gal) {
    var imgs = Array.prototype.slice.call(gal.querySelectorAll('.fgm-gal__img'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.fgm-gthumb'));
    if (imgs.length < 2 && thumbs.length < 2) return;
    var idx = 0;
    function show(i) {
      idx = (i + imgs.length) % imgs.length;
      // load the image being shown + its neighbours so nav is instant
      fgmLoadImg(imgs[idx]);
      fgmLoadImg(imgs[(idx + 1) % imgs.length]);
      fgmLoadImg(imgs[(idx - 1 + imgs.length) % imgs.length]);
      imgs.forEach(function (im, n) { im.classList.toggle('is-active', n === idx); });
      thumbs.forEach(function (t, n) {
        var on = n === idx;
        t.classList.toggle('is-active', on);
        if (on && t.scrollIntoView) {
          t.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
        }
      });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = gal.querySelector('.fgm-gal__nav--prev');
    var next = gal.querySelector('.fgm-gal__nav--next');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    /* touch swipe */
    var x0 = null;
    var main = gal.querySelector('.fgm-gal__main');
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
        x0 = null;
      }, { passive: true });
    }

    /* once the page is idle, quietly load the rest of the gallery one after another */
    function loadRest() { imgs.forEach(fgmLoadImg); }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadRest, { timeout: 2500 });
    } else {
      window.addEventListener('load', function () { setTimeout(loadRest, 400); });
    }
  });

  /* ---- sticky mobile add-to-cart ---- */
  var sticky = document.querySelector('.fgm-pdp-sticky');
  if (!sticky) return;
  var mainBtn = document.getElementById(sticky.getAttribute('data-target'));
  var anchor = document.querySelector('.fgm-pdp__buy .product-form__buttons') || mainBtn;
  if (!anchor) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
  }, { threshold: 0 });
  io.observe(anchor);

  var stickyBtn = sticky.querySelector('.fgm-pdp-sticky__btn');
  if (stickyBtn && mainBtn) {
    stickyBtn.addEventListener('click', function () { mainBtn.click(); });
  }
})();

/* ---- self-contained variant picker ----
   Resolves the selected variant client-side and drives the form's variant id,
   price display, and Add-to-cart state. Does NOT rely on Dawn's section re-fetch
   (which fails to resolve variants on these legacy-imported products), so the
   selected chip + Add-to-cart work every time. */
(function () {
  'use strict';
  var box = document.querySelector('[data-fgm-variants]');
  var dataEl = document.querySelector('[data-fgm-variant-data]');
  if (!box || !dataEl) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!Array.isArray(variants) || !variants.length) return;

  var scope = box.closest('product-info') || document;
  var idInput = scope.querySelector('form[id^="product-form-"] input[name="id"]') || scope.querySelector('input[name="id"]');
  var submitBtn = scope.querySelector('[id^="ProductSubmitButton"]') || scope.querySelector('.product-form__submit');
  var nowEl = scope.querySelector('[data-fgm-now]');
  var wasEl = scope.querySelector('[data-fgm-was]');
  var saveEl = scope.querySelector('[data-fgm-save]');
  var stickyPrice = document.querySelector('.fgm-pdp-sticky__price');
  var labels = box.querySelectorAll('[data-fgm-optlabel]');
  var fieldsets = box.querySelectorAll('fieldset');

  function setSubmit(enabled, label) {
    if (!submitBtn) return;
    if (enabled) submitBtn.removeAttribute('disabled');
    else submitBtn.setAttribute('disabled', 'disabled');
    var span = submitBtn.querySelector('span');
    if (span && label) span.textContent = label;
  }

  function resolve() {
    var sel = [];
    fieldsets.forEach(function (fs) {
      var c = fs.querySelector('input:checked');
      sel.push(c ? c.value : null);
    });
    labels.forEach(function (el, i) { if (sel[i] != null) el.textContent = sel[i]; });

    var match = null;
    for (var k = 0; k < variants.length; k++) {
      var v = variants[k];
      if (v.options && v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; })) {
        match = v; break;
      }
    }

    if (!match) { setSubmit(false, 'Unavailable'); return; }
    if (idInput) {
      idInput.value = match.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (nowEl) { nowEl.textContent = match.price; nowEl.classList.toggle('is-sale', !!match.on_sale); }
    if (wasEl) {
      if (match.on_sale) { wasEl.textContent = match.compare; wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }
    if (saveEl) {
      if (match.on_sale && match.save > 0) { saveEl.textContent = 'Save ' + match.save + '%'; saveEl.hidden = false; }
      else { saveEl.hidden = true; }
    }
    if (stickyPrice) { stickyPrice.textContent = match.price; }
    // swap the gallery to the variant's assigned image (set in Shopify backend)
    if (match.media) {
      var gimg = document.querySelector('.fgm-gal__img[data-media-id="' + match.media + '"]');
      if (gimg) {
        fgmLoadImg(gimg);
        document.querySelectorAll('.fgm-gal__img').forEach(function (im) { im.classList.toggle('is-active', im === gimg); });
        document.querySelectorAll('.fgm-gthumb').forEach(function (t) {
          var on = t.getAttribute('data-media-id') === String(match.media);
          t.classList.toggle('is-active', on);
          if (on && t.scrollIntoView) { t.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' }); }
        });
      }
    }
    setSubmit(!!match.available, match.available ? 'Add to cart' : 'Sold out');
  }

  box.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) resolve();
  });
  resolve();
})();

/* ---- message-card quote: clamp to ~3 sentences with a blurred fade + Show more ---- */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-fgm-quote]').forEach(function (box) {
      var clip = box.querySelector('[data-fgm-quote-clip]');
      var btn = box.querySelector('[data-fgm-quote-toggle]');
      if (!clip || !btn) return;
      if (clip.scrollHeight - clip.clientHeight > 8) {
        btn.hidden = false;
      } else if (clip.classList.contains('is-clamped')) {
        clip.classList.remove('is-clamped');
        btn.hidden = true;
      }
      if (!btn.dataset.fgmBound) {
        btn.dataset.fgmBound = '1';
        btn.addEventListener('click', function () {
          var clamped = clip.classList.toggle('is-clamped');
          btn.textContent = clamped ? 'Show more' : 'Show less';
        });
      }
    });
  }
  if ('requestAnimationFrame' in window) {
    requestAnimationFrame(init);
  } else {
    init();
  }
  // re-check once webfonts settle (height can change)
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(init); }
})();

/* ---- reviews: reveal 6 more per click (delegated, so timing can't break it) ---- */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fgm-reviews-more]') : null;
    if (!btn) return;
    e.preventDefault();
    var grid = document.querySelector('[data-fgm-reviews]');
    if (!grid) return;
    var hidden = grid.querySelectorAll('[data-fgm-more][hidden]');
    var n = Math.min(6, hidden.length);
    var firstRevealed = hidden[0] || null;
    for (var i = 0; i < n; i++) { hidden[i].hidden = false; }
    if (firstRevealed && firstRevealed.scrollIntoView) {
      firstRevealed.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    if (grid.querySelectorAll('[data-fgm-more][hidden]').length === 0) { btn.hidden = true; }
  });
})();

/* ---- delivery estimate: refresh to N business days from TODAY (visitor's date) ---- */
(function () {
  'use strict';
  var box = document.querySelector('[data-fgm-eta]');
  if (!box) return;
  var min = parseInt(box.getAttribute('data-min'), 10); if (isNaN(min)) { min = 2; }
  var max = parseInt(box.getAttribute('data-max'), 10); if (isNaN(max)) { max = 6; }
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var mon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addBiz(n) {
    var d = new Date(), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) { added++; } }
    return d;
  }
  function fmt(d) { return days[d.getDay()] + ', ' + mon[d.getMonth()] + ' ' + d.getDate(); }
  var e = box.querySelector('[data-fgm-eta-early]');
  var l = box.querySelector('[data-fgm-eta-late]');
  if (e) { e.textContent = fmt(addBiz(min)); }
  if (l) { l.textContent = fmt(addBiz(max)); }
})();
